import React, {useEffect, useState} from 'react';
import {Button, ModalDialog, HorizontalRule, ButtonRow, Paragraph} from '@piggybank/core';
import commonConfig from 'config/commonConfig';
import {useDispatch, useSelector} from 'react-redux';
import {openSessionTimeout, finishApi, resetSessionTimeout} from 'redux/appAction';
import {getKnowNextStep} from 'redux/knowAction';

import apiConfig from '../api/apiConfig';

const SessionTimeout = () => {
  const timeoutResetTime = useSelector((state) => state.app.timeoutResetTime);
  const dispatch = useDispatch();

  let [countDownTimer, setCountDownTimer] = useState(undefined);
  let countDownMillisecond = 1000 * apiConfig.SESSION_TIME_OUT_COUNTDOWN_SECOND;

  let [considerTimer, setConsiderTimer] = useState(undefined);
  let considerMillisecond = 1000 * apiConfig.SESSION_TIME_OUT_CONSIDER_SECOND;

  const waitForDecision = () => {
    dispatch(openSessionTimeout());
    let timer = setTimeout(() => {
      dispatch(resetSessionTimeout());
      dispatch(finishApi());
      window.location.href = commonConfig.gsp.bankUrl;
    }, considerMillisecond);
    setConsiderTimer(timer);
  };

  const startCountDown = () => {
    clearTimeout(considerTimer);
    clearTimeout(countDownTimer);
    let timer = setTimeout(() => {
      waitForDecision();
    }, countDownMillisecond);
    setCountDownTimer(timer);
  };

  useEffect(() => {
    if (timeoutResetTime !== 0) {
      startCountDown();
    }
  }, [timeoutResetTime]);
  console.log('timeout;ResetTime', timeoutResetTime);
  return (
    <ModalDialog
      title={'Timeout alert'}
      show={timeoutResetTime === 0}
      getApplicationNode={() => document.getElementById('root')}
      dismissible={false}>
      <Paragraph marginBottom={6}>
        {`We noticed that your session has been inactive for sometime. For your security,
         you will be automatically back to accounts. Please confirm whether you want to continue this session.`}
      </Paragraph>
      <HorizontalRule hiddenOnSmallViewport={true} />
      <ButtonRow>
        <Button
          type="button"
          onClick={() => {
            dispatch(getKnowNextStep('accreditation'));
          }}>
          Continue
        </Button>
        <Button
          type="button"
          onClick={() => {
            dispatch(finishApi());
            window.location.href = commonConfig.gsp.bankUrl;
          }}
          secondary={true}>
          Back to accounts
        </Button>
      </ButtonRow>
    </ModalDialog>
  );
};

export default SessionTimeout;
